import React ,{lazy, Suspense}from "react";
import { connect } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { styled } from "@mui/material";
import { Theme } from "@mui/material/styles"; // Import Theme type
import LinearProgress from '@mui/material/LinearProgress';
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Profile from "../pages/profile";
//website pages

// import LoginPage from "../pages/login/Login";
// import Dashboard from "../pages/dashboard/Dashboard";
const Error = lazy(()=> import("../pages/error/"));
const Validations = lazy(()=> import("../pages/validations"));
const AddCompany = lazy(()=> import("../pages/companies/add"));
const Companies = lazy(()=> import("../pages/companies"))
const Teams = lazy(()=> import('../pages/teams'))
const CompanyValidations = lazy(()=> import("../pages/companyValidations"));
const Users = lazy(()=> import("../pages/users"));
const APIusers = lazy(()=> import("../pages/apiUsers"));
const Roles = lazy(()=> import('../pages/roles'))
const AdminUser = lazy(()=> import('../pages/adminUsers'))
const UPFAnnouncements = lazy(()=> import('../pages/upfAnnouncements'))
const IVCuration = lazy(()=> import("../pages/validations/Ivcuration"));
const LEVCuration = lazy(()=> import("../pages/validations/levCuration"));
const Dashboard = lazy(()=> import("../pages/dashboards"));
const APIValidations = lazy(()=> import("../pages/apiValidations"))
const APILevReport = lazy(()=> import("../pages/validations/LevApiReport"))
const APIIvReport = lazy(()=> import("../pages/validations/IvApiReport"))
const LiveUpdateValidations = lazy(()=> import("../pages/liveUpdateValidations"))




// ... Import other components here

// Define Props Interfaces
interface LayoutProps {
    children: React.ReactNode;
}

interface MainProps {
    open: boolean;
    children: React.ReactNode;
}

// Styled Components
const Layout = styled("div")<LayoutProps>(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    display: "flex",
    height: "100%",
    overflow: "hidden",
    width: "100%",
}));

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })<MainProps>(
    ({ theme, open, }) => ({
        flexGrow: 1,
        padding: theme.spacing(2),
        paddingTop: "64px",
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        ...(open && {
            transition: theme.transitions.create("margin", {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: "220px",
        }),
    })
);

// DefaultLayout Component
function DefaultLayout(props: any) {
    return (
        <Layout>
            <Header />
            <Sidebar />
            <Main open={props.sideNavState}>
                <Suspense fallback={<div ><LinearProgress /></div>}> 
                <Routes>
                    <Route path="/validations" element={<Validations />} />
                    <Route path="/validations/:uuid/iv" element={<IVCuration />} />
                    <Route path="/validations/:uuid/lev" element={<LEVCuration />} />              
                    <Route path="/companies/add" element={<AddCompany />} />
                    <Route path="/companies" element={<Companies />} />                  
                    <Route path="/companies/:uuid/teams" element={<Teams />} />
                    <Route path="/companies/:uuid/users" element={<Users />} />
                    <Route path="/companies/:uuid/api-users" element={<APIusers />} />
                    <Route path="/teams/:uuid/users" element={<Users />} />
                    <Route path="/companies/:uuid/validations" element={<CompanyValidations />} />
                    <Route path="/roles" element={<Roles />} />
                    <Route path="/adminUsers" element={<AdminUser />} />
                    <Route path="/upf-announcements" element={<UPFAnnouncements />} />
                    <Route path="/dashboards" element={<Dashboard />} />
                    <Route path="/user-profile" element={<Profile />} />
                    <Route path="/api-validations" element={<APIValidations/>} />
                    <Route path="/api-validations/:uuid/iv" element={<APIIvReport />} />
                    <Route path="/api-validations/:uuid/lev" element={<APILevReport />} />   
                    <Route path="/live-update-validations" element={<LiveUpdateValidations />} />
                   
                    <Route path="/*" element={<Error />} > </Route>
                </Routes>
                </Suspense>
            </Main>
        </Layout>
    );
}

const mapStateToProps = (state: any) => ({
    sideNavState: state.layout.sideNavOpen,
});

const mapDispatchToProps = (dispatch: any) => ({
    // Map your Redux dispatch actions here if needed
});

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout);
